import { Loader2 } from 'lucide-react';
import React from 'react'

export default function PageLoader() {
    return <div style={{
        height: "100%",
        width: "100%",
        display: 'grid',
        placeItems: 'center'
    }}>
        <Loader2 className="h-8 w-8 animate-spin" />
    </div>;
}
